import styled from "styled-components";

import { LexicalEditorInnerContainer } from "@LexicalEditor/component/organisms/LexicalEditorInner/styles";
import { EditorToolbar } from "@LexicalEditor/plugins/ToolbarPlugin/styles";

export const CommentsSectionTitle = styled.span`
  font: 500 1rem/1.7rem "Inter";
  color: ${({ theme }) => theme?.classwork?.imersive?.buttonTextColor};
`;

export const CommentsFeedIndexContainer = styled.div`
  width: 100%;
  margin-top: 2rem;

  @media (min-width: 850px) {
    width: 80%;
  }

  #comment-feed-post-editor-container {
    margin-top: 0.75rem;
  }

  > ${LexicalEditorInnerContainer},${EditorToolbar} {
    border-color: ${({ theme }) => theme.commentsFeed.editorBorder};
  }

  ${EditorToolbar} {
    gap: 0.25rem;

    button :not(:first-child):nth-child(3n - 2) {
      margin-left: 0.75rem;
    }
  }

  #admin-console-comments-feed-incognito {
    background-color: ${({ theme }) => theme.commentsFeed.editorBorder};
  }

  .editor-placeholder {
    top: 19px;
  }
`;

export const RowHierarchyContainer = styled.div`
  position: relative;

  ::before {
    content: "";
    position: absolute;
    width: 1px;
    background-color: ${({ theme }) => theme.commentsFeed.editorBorder};
    height: 100%;
    top: 10px;
    left: -27px;
  }
`;
